module.exports = __webpack_public_path__ + "static/assets/e4aad08ff6b3b3d59ba6a16b3ce00611.svg";